import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandJsaAddPage } from '../cabsand-jsa-add/cabsand-jsa-add';
@IonicPage()
@Component({
  selector: 'page-cabsand-jsa',
  templateUrl: 'cabsand-jsa.html',
})
export class CabsandJsaPage {
  jsaList: any = [];
  actionAllowed:boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getJlaList();
  }

 

  

  getJlaList() {
    this.jsaList = [];
    this.utiltiy.startLoading();
    this.api.get("/tansix_prestart/jsa/get", false)
      .then((result: any) => {
        console.log("result", result)
        this.jsaList = result.result;
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }


  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deleteJsa(id);
    }
    console.log("status", status);
  }


  deleteJsa(id) {
    this.api.delete(`/tansix_prestart/jsa/delete/${id}`, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.getJlaList();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }
  
  addjsa(){
   this.navCtrl.push(CabsandJsaAddPage, { param: null });
 }
 updateJsa(payload){
   this.navCtrl.push(CabsandJsaAddPage, { param: payload });
 }
 async getPermission(){
  this.actionAllowed =  await this.utiltiy.getPagePermission("cabsand-jsa-rw");
 }
}





// WEBPACK FOOTER //
// ./src/pages/cabsand-jsa/cabsand-jsa.ts